import React, { useEffect, useState } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [partidos, setPartidos] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ partido_id:'', nome:'', email:'', perfil:'assessor' });
  const [msg, setMsg] = useState('');

  const carregar = () => {
    api.get('/usuarios').then(r => setUsuarios(r.data)).catch(() => {});
    api.get('/partidos').then(r => setPartidos(r.data)).catch(() => {});
  };
  useEffect(() => { carregar(); }, []);

  const lista = filtro ? usuarios.filter(u => u.partido_id === filtro) : usuarios;

  const salvar = async () => {
    try {
      if (modal === 'novo') await api.post('/usuarios', form);
      else await api.put(`/usuarios/${modal.id}`, form);
      setMsg('Salvo!'); setModal(null); carregar();
    } catch(e) { setMsg(e.response?.data?.erro || 'Erro'); }
  };

  const resetSenha = async (id) => {
    if (!window.confirm('Resetar senha deste usuário?')) return;
    try { await api.post(`/usuarios/${id}/reset-senha`, { motivo:'Reset pelo painel' });
      setMsg('Senha resetada e enviada por e-mail!'); } catch(e) { setMsg('Erro'); }
  };

  const desativar = async (id) => {
    if (!window.confirm('Desativar este usuário?')) return;
    try { await api.delete(`/usuarios/${id}`, { data:{ motivo:'Desativado pelo painel' } }); carregar(); setMsg('Desativado!'); } catch(e) { setMsg('Erro'); }
  };

  const cores = { candidato:'#E6F1FB', assessor:'#FAEEDA', contador:'#E1F5EE', partido_admin:'#FAECE7' };
  const tcores = { candidato:'#185FA5', assessor:'#633806', contador:'#085041', partido_admin:'#993C1D' };

  return (
    <Layout title="Usuários dos partidos">
      {msg && <div style={s.msg}>{msg} <button onClick={() => setMsg('')} style={s.close}>×</button></div>}
      <div style={s.bar}>
        <select style={s.sel} value={filtro} onChange={e => setFiltro(e.target.value)}>
          <option value="">Todos os partidos</option>
          {partidos.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
        </select>
        <button style={s.btn} onClick={() => { setForm({partido_id:partidos[0]?.id||'',nome:'',email:'',perfil:'assessor'}); setModal('novo'); }}>+ Novo usuário</button>
      </div>
      <div style={s.table}>
        <div style={s.thead}><span>Nome</span><span>E-mail</span><span>Perfil</span><span>Partido</span><span>Status</span><span>Ações</span></div>
        {lista.map(u => (
          <div key={u.id} style={s.row}>
            <span style={s.name}>{u.nome}</span>
            <span style={s.email}>{u.email}</span>
            <span><span style={{...s.badge, background:cores[u.perfil], color:tcores[u.perfil]}}>{u.perfil}</span></span>
            <span style={s.partido}>{u.partido_nome}</span>
            <span><span style={{...s.status, background:u.ativo?'#EAF3DE':'#FCEBEB', color:u.ativo?'#3B6D11':'#A32D2D'}}>{u.ativo?'Ativo':'Inativo'}</span></span>
            <span style={s.actions}>
              <button style={s.abtn} onClick={() => { setForm({partido_id:u.partido_id,nome:u.nome,email:u.email,perfil:u.perfil,ativo:u.ativo}); setModal(u); }}>✏️</button>
              <button style={s.abtn} onClick={() => resetSenha(u.id)}>🔑</button>
              <button style={{...s.abtn,color:'#e74c3c'}} onClick={() => desativar(u.id)}>🗑️</button>
            </span>
          </div>
        ))}
      </div>
      {modal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <h3 style={s.mtitle}>{modal==='novo'?'Novo usuário':'Editar usuário'}</h3>
            <div style={s.field}><label>Partido</label>
              <select style={s.input} value={form.partido_id} onChange={e => setForm({...form,partido_id:e.target.value})}>
                {partidos.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
              </select>
            </div>
            <div style={s.field}><label>Nome</label><input style={s.input} value={form.nome} onChange={e => setForm({...form,nome:e.target.value})} /></div>
            <div style={s.field}><label>E-mail</label><input style={s.input} type="email" value={form.email} onChange={e => setForm({...form,email:e.target.value})} /></div>
            <div style={s.field}><label>Perfil</label>
              <select style={s.input} value={form.perfil} onChange={e => setForm({...form,perfil:e.target.value})}>
                <option value="candidato">Candidato</option>
                <option value="assessor">Assessor</option>
                <option value="contador">Contador</option>
                <option value="partido_admin">Admin do partido</option>
              </select>
            </div>
            <div style={s.mfoot}>
              <button style={s.cbtn} onClick={() => setModal(null)}>Cancelar</button>
              <button style={s.btn} onClick={salvar}>Salvar</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

const s = {
  msg:{background:'#EAF3DE',color:'#3B6D11',padding:'10px 16px',borderRadius:8,marginBottom:16,display:'flex',justifyContent:'space-between'},
  close:{background:'none',border:'none',cursor:'pointer',fontSize:18},
  bar:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20},
  sel:{padding:'8px 12px',border:'1px solid #ddd',borderRadius:8,fontSize:13},
  btn:{background:'#534AB7',color:'#fff',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer'},
  table:{background:'#fff',borderRadius:12,overflow:'hidden',boxShadow:'0 1px 4px rgba(0,0,0,0.06)'},
  thead:{display:'grid',gridTemplateColumns:'1.5fr 2fr 1fr 1.2fr 0.8fr 1fr',padding:'12px 20px',background:'#f8f9fa',fontSize:12,fontWeight:600,color:'#888',gap:8},
  row:{display:'grid',gridTemplateColumns:'1.5fr 2fr 1fr 1.2fr 0.8fr 1fr',padding:'14px 20px',borderTop:'1px solid #f0f0f0',alignItems:'center',gap:8,fontSize:13},
  name:{fontWeight:500,color:'#1a1a2e'},
  email:{color:'#666'},
  badge:{padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:500},
  partido:{color:'#534AB7',fontSize:12},
  status:{padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:500},
  actions:{display:'flex',gap:6},
  abtn:{background:'none',border:'1px solid #eee',borderRadius:6,padding:'4px 8px',cursor:'pointer',fontSize:14},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:100},
  modal:{background:'#fff',borderRadius:16,padding:28,width:380},
  mtitle:{margin:'0 0 20px',fontSize:16,fontWeight:600},
  field:{display:'flex',flexDirection:'column',gap:6,marginBottom:14},
  input:{padding:'9px 12px',border:'1px solid #ddd',borderRadius:8,fontSize:13},
  mfoot:{display:'flex',justifyContent:'flex-end',gap:10,marginTop:20},
  cbtn:{background:'#f0f0f0',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,cursor:'pointer'},
};
